export default function clonePoint3(point) {
    return point ? [point[0], point[1], point[2]] : undefined;
}
